/* eslint-disable max-len */
import { Link } from "react-router-dom";
// @ts-ignore
import "./Footer.scss";
import { joinClassNames } from "utils/join-class-names";

export interface IFooterProps {
  className?: string;
}

const Footer = ({ className = "" }: IFooterProps): JSX.Element => {
  return (
    <footer
      className={joinClassNames(
        "app-footer h-[50px] w-full flex justify-center items-center gap-x-4 gap-y-0.5 px-8 whitespace-nowrap flex-wrap md:flex-nowrap",
        className
      )}
    >
      <a href="mailto:info@pointmentapp.com">info@pointmentapp.com</a>
      <div>•</div>
      <div>© Pointment {new Date().getFullYear()}</div>
      <div className="flex justify-center items-center text-center gap-x-4 gap-y-0.5 ml-[-9px] sm:ml-0">
        <div className="hidden sm:block">•</div>
        <Link to="/toc">Terms and Conditions</Link>
        <div>•</div>
        <Link to="/privacypolicy">Privacy Policy</Link>
        <div>•</div>
        <Link to="/cookie-policy">Cookie Policy</Link>
      </div>
    </footer>
  );
};

export default Footer;
